<template>
  <v-row class="match-height">
    <!-- search client -->
    <v-col
      cols="12"
      md="12"
    >
      <v-card>
        <v-card-title>Search Client</v-card-title>
        <v-card-text>
          <search-client />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import SearchClient from '@/components/users/search-client.vue'

export default {
  components: {
    SearchClient,
  },
  setup() {
    return {}
  },

  mounted() {
    //
  },
}
</script>
